import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import NotesProject from './notesProject';

const enhance = compose(
  withNamespaces(['common', 'tasks']),
);
export default enhance(NotesProject);
